module.exports = __webpack_public_path__ + "media/vsl.8d838339.mp4";